export default __webpack_public_path__ + "static/netw-consulting-f50807dfa8d4ed9d4909da27c531397a.webp";